<template>
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><path
    d="M5.898 3.555a2.344 2.344 0 1 0 4.688 0 2.344 2.344 0 0 0-4.688 0Z"
    stroke="currentColor"
    stroke-width="1.25"
    stroke-linecap="round"
    stroke-linejoin="round"
  /><path
    d="M8.242 5.898v5.86a1.172 1.172 0 0 0 1.172 1.172h3.516a2.344 2.344 0 0 1 2.343 2.343v3.516h1.172"
    stroke="currentColor"
    stroke-width="1.25"
    stroke-linecap="round"
    stroke-linejoin="round"
  /><path
    d="M12.93 9.414H8.242a4.688 4.688 0 1 0 4.688 4.688V12.93"
    stroke="currentColor"
    stroke-width="1.25"
    stroke-linecap="round"
    stroke-linejoin="round"
  /></svg>
</template>
